import { findMissingRequired, requiredTitles, type RequiredCandidate } from '@/utils/requiredCells'
import { COMBO_MAX_LENGTH, MESSAGES } from './consts'
import type { ComboRow } from './queries/useGetComboList'

type ComboCells = Pick<ComboRow, keyof typeof COMBO_MAX_LENGTH>

const LENGTH_KEYS = Object.keys(COMBO_MAX_LENGTH) as (keyof typeof COMBO_MAX_LENGTH)[]

/**
 * 저장 전 검증 — 걸리면 안내 문구, 통과면 undefined. BE 가 400 으로 거부하는 필수 누락·길이 초과만 본다(LOGISPRD-17281).
 * 같은 콤보코드·옵션코드 중복과 형식은 막지 않는다 — 1.0 SY05 도 막지 않았다(insertForm.py·updateForm.py).
 * required = 화면관리 설정을 반영한 필수 칸(forTable(id).columns).
 */
export const invalidReason = (rows: ComboCells[], required: RequiredCandidate[]): string | undefined => {
  if (findMissingRequired(rows, required)) return MESSAGES.requiredCells(requiredTitles(required))
  if (rows.some((r) => LENGTH_KEYS.some((k) => r[k].trim().length > COMBO_MAX_LENGTH[k]))) return MESSAGES.tooLong
  return undefined
}
